<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card>
              <v-toolbar color="primary">
                <v-toolbar-title>Bem vindo</v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="logo">
                  <v-img src="https://s3-us-west-2.amazonaws.com/assets.usemimon.com/logos/white-logo.png"   contain height="75" width="100"/>
                </div>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form">
                  <v-text-field
                    label="Email"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    @keyup.enter.native="onLogin"
                    v-model="email"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    label="Senha"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    @keyup.enter.native="onLogin"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn :class="`d-flex m-auto justify-center mb-6`" color="primary" width="150" height="40" @click="onLogin">Entrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
  .logo { border-radius: 50%; }
  .v-btn { margin: 0 auto 5px; }
</style>

<script>
import router from '@/router'
import { Auth } from 'aws-amplify'

export default {
  name: 'Login',
  data: () => ({
    email: '',
    password: ''
  }),
  methods: {
    async onLogin () {
      await Auth.signIn(this.email, this.password)
        .then(user => router.push({ path: '/dashboard' }))
    }
  },
  created () {
    this.$vuetify.theme.dark = true
  },
  async mounted () {
    await Auth.currentSession().then(user => router.push({ path: '/dashboard' }))
  }
}
</script>
